import { useState } from "react";

import ReactTable from "../../components/custom/ReactTable";
import { IUser, IVisualReporting } from "../../globals/interfaces";
import { IDamageReportItem, generateDamageReport, getDamageReportMap } from '../../components/warehouse/damageReporting/utils';
import VisualReportingModal from './VisualReportingModal'
import { useAppContext } from "../../context";
import { getUserStation } from "../../utils";
import useAppData from "../../customHooks/useAppData";

interface Props {
    data: Array<IVisualReporting>;
    user: IUser
}

export default function VisualReporting ({
    data,
    user
}: Props) {

    const { setLoading } = useAppContext();
    const { stations } = useAppData();
    const userStation = getUserStation(stations, user);
    const dataMap = getDamageReportMap(data);
    const [viewModal, setViewModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<IDamageReportItem>();
    
    const handleViewItem = (item: IDamageReportItem) => {
        setSelectedItem(item);
        setViewModal(true);
    }

    const generateReport = (item: IDamageReportItem) => {
        const { user_submitted, time_submitted, comments, awb_uld, collection_id, file_links } = item;
        generateDamageReport(
            'print',
            user,
            userStation,
            user_submitted,
            time_submitted,
            comments,
            file_links,
            awb_uld,
            'DAMAGE', 
            collection_id, 
            setLoading,
        );
    }


    return (
        <>
            <ReactTable 
                data={Object.keys(dataMap).map(key => dataMap[key])}
                mapping={[{
                    name: 'Submitted by',
                    value: 'full_name',
                }, {
                    name: 'AWB/ULD',
                    value: 'awb_uld'
                }, {
                    name: 'Comments',
                    value: 'comments'
                }, {
                    name: 'Link',
                    value: 'file_link'
                }, {
                    name: 'Unit',
                    value: 'unit'
                }, {
                    name: 'Print',
                    value: 'fas fa-print',
                    icon: true,
                    function: (item: IDamageReportItem) => generateReport(item)
                }]}
                enableClick
                handleClick={handleViewItem}
            />
            <VisualReportingModal 
                modal={viewModal}
                setModal={setViewModal}
                item={selectedItem}
            />
        </>
    );
}